export const getCurrencySymbol = (currencyUnit = 'USD') => {
  switch (currencyUnit) {
    case 'AUD':
      return 'A$';
    case 'GBP':
      return '£';
    case 'USD':
    default:
      return '$';
  }
};

export const getCoinPriceDollarAmount = (number: number) => number / 100;
